import { motion } from "framer-motion";
import { Send, ArrowUpRight } from "lucide-react";
import { T } from "@/constants/testIds";
import { LINKS, ASSETS } from "@/constants/links";
import XIcon from "@/components/XIcon";

const NAV = [
  ["#stats", "Burn"],
  ["#tv", "DIH TV"],
  ["#lore", "Doctrine"],
  ["#buy", "Buy"],
];

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1], delay: 0.1 }}
      className="fixed top-3 md:top-5 left-0 right-0 z-50 px-3 md:px-6"
      data-testid={T.nav}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between gap-3 bg-ink/95 backdrop-blur-md text-paper rounded-full pl-2 pr-2 py-2 border-2 border-black shadow-[4px_4px_0_rgba(0,0,0,0.35)]">
        <a href="#top" data-testid={T.navLogo} className="flex items-center gap-3 pl-1">
          <img
            src={ASSETS.logo}
            alt="DIH"
            className="w-10 h-10 rounded-full object-cover border-2 border-[color:var(--lime)]"
          />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-display text-sm tracking-tight text-lime">DOG IN HOOD</span>
            <span className="font-mono text-[10px] text-[color:var(--muted)] tracking-widest mt-1">
              $DIH · ROBINHOOD CHAIN
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-7 font-mono text-[11px] uppercase tracking-[0.2em] text-paper/70">
          {NAV.map(([href, label]) => (
            <a key={href} href={href} className="hover-underline hover:text-lime transition-colors">
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={LINKS.twitter}
            target="_blank"
            rel="noreferrer"
            data-testid={T.navTwitter}
            aria-label="X"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/15 hover:border-[color:var(--lime)] hover:text-lime transition-colors"
          >
            <XIcon size={14} />
          </a>
          <a
            href={LINKS.telegram}
            target="_blank"
            rel="noreferrer"
            data-testid={T.navTelegram}
            aria-label="Telegram"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/15 hover:border-[color:var(--lime)] hover:text-lime transition-colors"
          >
            <Send size={14} />
          </a>
          <a
            href={LINKS.uniswap}
            target="_blank"
            rel="noreferrer"
            data-testid={T.navBuy}
            className="btn btn-lime btn-sm !border-[color:var(--lime)] !shadow-none hover:!shadow-none"
          >
            <span className="hidden sm:inline">Buy on Uniswap</span>
            <span className="sm:hidden">Buy</span>
            <ArrowUpRight size={14} />
          </a>
        </div>
      </div>
    </motion.header>
  );
}
